import gql from 'graphql-tag';
import { miniUserFragment } from '../fragments/mini-user.fragment';

export const unFollowUserMutation = gql`
  mutation unfollow($followeeId: ID!) {
    unfollow(followeeId: $followeeId) {
      operationResult
      modifiedUser {
        ...miniUserFragment
      }
      me {
        ...miniUserFragment
      }
    }
  }
  ${miniUserFragment}
`;
